import { useForm } from 'react-hook-form';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Field, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { FocusHighlightCard } from './FocusHighlightCard';
import type { SectionProps } from './types';

type AssignedLocationFormValues = {
  branch: string;
  division: string;
  walaGroup: string;
  stagingArea: string;
};

export function CardAssignedLocation({
  row,
  upsertWala,
  canEditCards,
}: SectionProps) {
  const defaultValues: AssignedLocationFormValues = {
    branch: row.original.branch ?? '',
    division: row.original.division ?? '',
    walaGroup: row.original.walaGroup ?? '',
    stagingArea: row.original.stagingArea ?? '',
  };

  const { register, handleSubmit, reset } = useForm<AssignedLocationFormValues>(
    { defaultValues }
  );

  const onSubmit = handleSubmit((values) => {
    upsertWala(row, values);

    (document.activeElement as HTMLElement | null)?.blur();
  });

  return (
    <FocusHighlightCard className="tw:w-1/3" size="sm">
      <CardHeader>
        <CardTitle>3. Assigned Location</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="tw:grid tw:gap-4">
          <div className="tw:grid tw:grid-cols-2 tw:gap-2">
            <Field>
              <FieldLabel htmlFor="assigned-location-branch">Branch</FieldLabel>
              <Input id="assigned-location-branch" {...register('branch')} />
            </Field>
            <Field>
              <FieldLabel htmlFor="assigned-location-division">
                Division
              </FieldLabel>
              <Input
                id="assigned-location-division"
                {...register('division')}
              />
            </Field>
            <Field>
              <FieldLabel htmlFor="assigned-location-group">Group</FieldLabel>
              <Input id="assigned-location-group" {...register('walaGroup')} />
            </Field>
            <Field>
              <FieldLabel htmlFor="assigned-location-staging-area">
                Staging Area
              </FieldLabel>
              <Input
                id="assigned-location-staging-area"
                {...register('stagingArea')}
              />
            </Field>
          </div>
          <div className="tw:invisible tw:flex tw:gap-2 tw:group-focus-within/card:visible">
            <Button type="submit" size="sm" disabled={!canEditCards}>
              Save
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={(event) => {
                reset(defaultValues);
                event.currentTarget.blur();
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </CardContent>
    </FocusHighlightCard>
  );
}
